import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../mock';

const ServicesOverview = () => {
  return (
    <section id="services" className="relative py-24 lg:py-36 bg-ivory overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="gold-divider"></span>
              <span className="font-mono-label text-gold-dark">Our Practice</span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-[3.4rem] leading-[1.05] text-ink">
              Are you facing <span className="italic text-gold-dark">these</span> problems too?
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="font-sans-body text-lg text-muted-kmh leading-relaxed">
              Seven specialised verticals, one obsessive standard. From PoSH to FEMA, every engagement is
              architected for accuracy, defensibility, and quiet confidence in the boardroom.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
          {services.map((s, idx) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              className="group relative bg-ivory hover:bg-paper p-8 lg:p-10 card-lift"
            >
              <div className="flex items-start justify-between">
                <span className="font-mono-label text-gold">{String(idx + 1).padStart(2, '0')}</span>
                <ArrowUpRight className="w-5 h-5 text-ink-soft group-hover:text-gold-dark group-hover:rotate-12" />
              </div>
              <div className="mt-12">
                <p className="font-mono-label text-gold-dark mb-3">{s.badge}</p>
                <h3 className="font-serif-display text-2xl lg:text-3xl text-ink leading-tight">{s.title}</h3>
                <p className="font-sans-body text-sm text-muted-kmh leading-relaxed mt-4">{s.summary}</p>
                <span className="link-underline font-mono-label text-ink mt-8 inline-block">Learn More</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
